module.exports = __webpack_public_path__ + "img/Logo.cb62f334.svg";